import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { IconComponent } from '../icon/icon.component';

// import {Offcanvas} from 'bootstrap'
declare const bootstrap: any;

@Component({
  selector: 'app-drawer',
  standalone: true,
  imports: [CommonModule, IconComponent],
  templateUrl: './drawer.component.html',
  styleUrls: ['./drawer.component.css'],
})
export class DrawerComponent implements AfterViewInit {
  @ViewChild('sidebarElement') sidebarElement!: ElementRef;

  @Input() title: string = 'Drawer Title';
  @Input() visible: boolean = false;
  @Input() sideBarTriggerId: string = 'custom-drawer';

  @Output() onClose = new EventEmitter<void>();
  offCanvasInstance: any

  ngAfterViewInit(): void {
    this.offCanvasInstance = new bootstrap.Offcanvas(this.sidebarElement.nativeElement)
    document.addEventListener('click', this.handleOutsideClick, true);
    if (this.visible) {
      this.offCanvasInstance.show();
    }
  }

  handleOutsideClick = (event: MouseEvent) => {
    const clickedInside = this.sidebarElement.nativeElement.contains(
      event.target
    );
    if (!clickedInside && this.visible) {
      this.closeDrawer();
    }
  };


  closeDrawer() {
    this.offCanvasInstance.hide()
    this.onClose.emit();
  }
}
